
    import NsHeaderTop from "./NsHeaderTop.vue"
    import NsHeaderMid from "./NsHeaderMid.vue"
    export default {
        components: {
            NsHeaderTop,
            NsHeaderMid
        },
        created() {
            this.$store.dispatch("cart/cart_count")
            this.$store.dispatch("wholesaleCart/cart_count")
        }
    }
